// extracted by mini-css-extract-plugin
export default {"container":"GdprDownloadSection_container__mSA3u","text":"GdprDownloadSection_text__u-PO8","link":"GdprDownloadSection_link__e1wTQ"};